<woa-modal-page-layout [title]="'woa.heading.participantName.title'"
                       [contentText]="'woa.message.participantName.instructions'"
                       [translationParams]="{'groupOrderName': transferTargetName()}">
    <woa-form (onSubmit)="confirmName()">
        <woa-text-field [(ngModel)]="name" name="name" [label]="'woa.label.common.firstName'"
                        required [maxlength]="'50'" [autocomplete]="'given-name'"></woa-text-field>
    </woa-form>
    <woa-button woa-page-footer-control [label]="'woa.button.participantName.confirm'"
                (onActivate)="form().submit()"></woa-button>
</woa-modal-page-layout>
